// src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/800.css";
import "@fontsource/montserrat/900.css";
import { ThemeProvider, CssBaseline } from "@mui/material";
import muiTheme from "./theme/muiTheme";
import { SnackbarProvider } from "./Components/Snackbar/SnackbarContext";
import DashboardLayout from "./Layout";
import AdminDashboard from "./Pages/AdminDashboard";
import TeacherDashboard from "./Pages/TeacherDashboard";
import StaffManagement from "./Components/Admin/Staff/Staff";
import StaffDetail from "./Components/Admin/Staff/StaffDetail";
import AddStaffForm from "./Components/Admin/Staff/AddStaff";
import ClassSetup from "./Components/Admin/Class/ClassSetup";
import AnnouncementPage from "./Components/Admin/Announcement/Announcement";
import MarkAttendance from "./Components/Teacher/Attendance/Attendance";
import ViewAttendance from "./Components/Teacher/Attendance/ViewAttendance";
import Login from "./Pages/Login";
import StudentListing from "./Components/Student/Student";
import AddStudentForm from "./Components/Student/AddStudent";
import StudentDetail from "./Components/Student/StudentDetail";
import AdminFees from "./Pages/Fees/Fees";
import StaffProfile from "./Pages/StaffProfile";
import AdminProfile from "./Pages/AdminProfile";
import AdminActivities from "./Components/Activity/AdminActivities";
import AdminBranches from "./Components/Branch/AdminBranches";
import TimetableApp from "./Components/Admin/Timetable/Timetable";
import ProtectedRoute from "./Components/protected_route/index";
import MarkStaffAttendanceUI from "./Components/Admin/StaffAttendance/MarkStaffAttendance";
import TeacherTimetable from "./Components/Teacher/TimetabeView/TeacherTimetable";
import ProgressTrackingPage from "./Components/Teacher/ProgressTracking/ProgressTrackingPage";
import ViewStaffAttendanceUI from "./Components/Admin/StaffAttendance/ViewStaffAttendance";
import EventCalendar from "./Components/Calendar/EventCalendar";
import UploadData from "./Pages/UploadData";
import ViewData from "./Pages/ViewData";
import DiaryListing from "./Components/Diary/DiaryListing";
import DiaryForm from "./Components/Diary/DiaryForm";
import DiaryDetail from "./Components/Diary/DiaryDetail";
import Enquiries from "./Components/Admin/Enquiries/Enquiries";
import ScheduleVisits from "./Components/Admin/ScheduleVisits/ScheduleVisits";
import Settings from "./Components/Admin/Settings/Settings";

function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <SnackbarProvider>
        <Router>
          <Routes>
            {/* LOGIN */}
            <Route path="/" element={<Login />} />

            <Route element={<ProtectedRoute />}>
              {/* ========= ADMIN ROUTES ========== */}
              <Route path="/admin" element={<DashboardLayout role="admin" />}>
                <Route index element={<AdminDashboard />} />
                <Route path="admin-profile" element={<AdminProfile />} />
                <Route path="staff-page" element={<StaffManagement />} />
                <Route path="staff/add" element={<AddStaffForm mode="add" />} />
                <Route
                  path="staff/edit/:id"
                  element={<AddStaffForm mode="edit" />}
                />
                <Route path="AdminBranches" element={<AdminBranches />} />
                <Route path="activity" element={<AdminActivities />} />
                <Route path="upload-data" element={<UploadData />} />
                <Route path="view-data" element={<ViewData />} />
                <Route path="staff/:id" element={<StaffDetail />} />
                <Route path="fees" element={<AdminFees />} />
                <Route path="class" element={<ClassSetup />} />
                <Route path="student-listing" element={<StudentListing />} />
                <Route path="add-student" element={<AddStudentForm />} />
                <Route path="students/:id" element={<StudentDetail />} />
                <Route path="announcement" element={<AnnouncementPage />} />
                <Route path="timetable" element={<TimetableApp />} />
                <Route path="progress" element={<ProgressTrackingPage />} />
                <Route path="calender" element={<EventCalendar />} />
                <Route
                  path="staff-markattendance"
                  element={<MarkStaffAttendanceUI />}
                />
                <Route
                  path="staff-viewattendance"
                  element={<ViewStaffAttendanceUI />}
                />
                <Route path="diary" element={<DiaryListing />} />
                <Route path="diary/add" element={<DiaryForm mode="add" />} />
                <Route path="diary/edit/:id" element={<DiaryForm mode="edit" />} />
                <Route path="diary/:id" element={<DiaryDetail />} />
                <Route path="enquiries" element={<Enquiries />} />
                <Route path="schedule-visits" element={<ScheduleVisits />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Route>

            <Route element={<ProtectedRoute />}>
              {/* ========= STAFF / TEACHER ROUTES ========== */}
              <Route
                path="/teacher"
                element={<DashboardLayout role="teacher" />}
              >
                <Route index element={<TeacherDashboard />} />

                {/* 🔥 MUST NOT HAVE SLASH */}
                <Route path="staff-profile" element={<StaffProfile />} />
                <Route path="activity" element={<AdminActivities />} />
                <Route path="student-listing" element={<StudentListing />} />
                <Route path="add-student" element={<AddStudentForm />} />
                <Route path="students/:id" element={<StudentDetail />} />
                <Route path="attendance" element={<ViewAttendance />} />
                <Route path="mark-attendance" element={<MarkAttendance />} />
                <Route path="announcement" element={<AnnouncementPage />} />
                <Route path="progress" element={<ProgressTrackingPage />} />
                <Route path="calender" element={<EventCalendar />} />
                <Route
                  path="timetable"
                  element={<TeacherTimetable teacherName="Mrs. Sharma" />}
                />
                <Route path="diary" element={<DiaryListing />} />
                <Route path="diary/add" element={<DiaryForm mode="add" />} />
                <Route path="diary/edit/:id" element={<DiaryForm mode="edit" />} />
                <Route path="diary/:id" element={<DiaryDetail />} />
              </Route>
            </Route>
          </Routes>
        </Router>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;